import React, { ComponentPropsWithoutRef } from 'react';

import { Typography } from 'ucl/components/text/Typography';

import { A11yWrapper } from 'components/a11y-wrapper';
import Currency from 'components/currency';
import { CurrencyLineSkeleton } from 'pages/cart/currency-line-skeleton';
import { t } from 'state/intl/translations';

import { Total, TotalLabel, TotalsRow } from './styled';

type TextProps = ComponentPropsWithoutRef<typeof Typography>;

export const TaxesRow: React.FC<React.PropsWithChildren<{
  taxCents: number;
  isLoading?: boolean;
  mb?: string | number;
  mt?: string | number;
  textProps?: TextProps;
}>> = ({ taxCents, isLoading, mb = '$0', mt = '$0', textProps }) => {
  return (
    <TotalsRow mb={mb} mt={mt}>
      {isLoading ? (
        <CurrencyLineSkeleton />
      ) : (
        <>
          <A11yWrapper>
            <TotalLabel {...(textProps && { fontSize: 'md' })}>{t('tax')}</TotalLabel>
          </A11yWrapper>
          <Total>
            <Currency textProps={textProps} amount={taxCents} testID="totalTax" />
          </Total>
        </>
      )}
    </TotalsRow>
  );
};
